export default ({ nuxtState }, inject) => {
    const observer = new IntersectionObserver(handleLazyLoading)
    const elements = {}
    const callbacks = {}

    function load(element, key, callback) {
        unload(key)
        if (element) {
            elements[key] = element
            callbacks[key] = callback
            observer.observe(element)
        }
    }

    function unload(key) {
        if (elements[key]) observer.unobserve(elements[key])
    }

    function handleLazyLoading(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const key = Object.keys(elements).find((key) => elements[key] === entry.target)
                if (key) {
                    callbacks[key]()
                    unload(key)
                }
            }
        })
    }

    inject('lazyload', { load, unload })
}
